import { Outlet } from 'react-router-dom';
import { CompaniesHeader } from './components/companies-header.component';
import { PageListLayout } from '../../components/layout/page-list-layout';

export function CompaniesLayout() {
  return (
    <PageListLayout>
      <CompaniesHeader />
      <Outlet />
    </PageListLayout>
  );
}
